import { render, staticRenderFns } from "./ProvisionPackageReport.vue?vue&type=template&id=08fb33c3&"
import script from "./ProvisionPackageReport.vue?vue&type=script&lang=js&"
export * from "./ProvisionPackageReport.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionPackageReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports